import { Components, Theme } from '@mui/material';

const muiInputBase: Components<Theme>['MuiInputBase'] = {
	styleOverrides: {
		root: ({ theme }) => ({
			...theme.typography.input,
			'&.Mui-error': {
				color: theme.palette.error.main,
			},
			variants: [
				{
					props: { size: 'small' },
					style: { height: '44px' },
				},
			],
		}),
		input: ({ theme }) => ({
			'&::placeholder': {
				opacity: 0.4,
				color: theme.palette.text.primary,
			},
		}),
	},
};

export default muiInputBase;
